import {
    LIST_EVENTS_SHOW_CREATE_POPUP,
    LIST_EVENTS_SHOW_EDIT_POPUP,
    LIST_EVENTS_HIDE_ALL_POPUPS,
    REQUEST_EVENT_TYPE_USAGE,
    RECEIVE_EVENT_TYPE_USAGE,
    RECEIVE_EVENT_TYPE_USAGE_ERROR,
} from '../actions/listEventTypes';
import {
    OPTIMISTIC_CREATE_EVENT_TYPE,
    OPTIMISTIC_UPDATE_EVENT_TYPE,
    OPTIMISTIC_DELETE_EVENT_TYPE,
} from '../../../global/actions/eventType';
const initialState = {
    showEditPopup: false,
    showCreatePopup: false,
    usage: {},
};

const listPriceCategoryDefinitions = (state = initialState, action) => {
    switch (action.type) {
        case LIST_EVENTS_SHOW_CREATE_POPUP:
            return {
                ...state,
                showCreatePopup: true,
            };
        case LIST_EVENTS_SHOW_EDIT_POPUP:
            return {
                ...state,
                showEditPopup: action.id,
            };
        case OPTIMISTIC_CREATE_EVENT_TYPE:
        case OPTIMISTIC_UPDATE_EVENT_TYPE:
        case OPTIMISTIC_DELETE_EVENT_TYPE:
        case LIST_EVENTS_HIDE_ALL_POPUPS:
            return {
                ...state,
                showCreatePopup: false,
                showEditPopup: false,
            };
        case REQUEST_EVENT_TYPE_USAGE:
            return {
                ...state,
                usage: {
                    ...state.usage,
                    [action.eventTypeId]: {
                        ...state.usage[action.eventTypeId],
                        [action.scope]: {
                            ...state.usage[action.eventTypeId]?.[action.scope],
                            loading: true,
                            error: null,
                        },
                    },
                },
            };
        case RECEIVE_EVENT_TYPE_USAGE: {
            const existingScope = state.usage[action.eventTypeId]?.[action.scope];
            const existingItems = existingScope?.items || [];
            const isAppending = action.data.meta?.page > 1 && existingItems.length > 0;

            return {
                ...state,
                usage: {
                    ...state.usage,
                    [action.eventTypeId]: {
                        ...state.usage[action.eventTypeId],
                        counts: action.data.counts,
                        [action.scope]: {
                            items: isAppending ? [...existingItems, ...action.data.items] : action.data.items,
                            meta: action.data.meta,
                            loading: false,
                            error: null,
                        },
                    },
                },
            };
        }
        case RECEIVE_EVENT_TYPE_USAGE_ERROR:
            return {
                ...state,
                usage: {
                    ...state.usage,
                    [action.eventTypeId]: {
                        ...state.usage[action.eventTypeId],
                        [action.scope]: {
                            ...state.usage[action.eventTypeId]?.[action.scope],
                            loading: false,
                            error: action.error,
                        },
                    },
                },
            };
        default:
            return state;
    }
};

export default listPriceCategoryDefinitions;
